import { Language } from "@feature/language";

export const setDocumentDir = (defaultLanguage: Language) => {
  if (defaultLanguage === Language.ARABIC) {
    document.dir = "rtl";
  } else {
    document.dir = "ltr";
  }
};
